export default {
    openLoginPage
};


function openLoginPage(to) {
    let url = `//${process.env.PREMIERE_URL}/login`;
    if (to.params.next) {
        url = `${url}/?dashboard_next=${to.params.next}`;
    }
    location.href = url;
}
